/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import moment from "moment";
import DayRangePicker from "@/components/DatePickers/DayPickers/DayRangePicker/DayRangePicker";
import { DateRange } from "@/components/DatePickers/shared/types";
import Tooltip from "@/components/Tooltip/Tooltip";
import { Typography } from "@mui/material";

import { colors, InfoIcon } from "@dotnet/telematics-design-system";

import { useStyles } from "../styles";

interface DownloadActivitesRangeProps {
  rangeValue: DateRange | null;
  handleActivitiesRangeChange: (value: DateRange | null) => void;
}

const DownloadActivitesRange = ({
  rangeValue,
  handleActivitiesRangeChange
}: DownloadActivitesRangeProps) => {
  const { t } = useTranslation();

  const { infoIconCSS, downloadActivitiesTitleCSS } = useStyles();

  return (
    <>
      <div css={css(downloadActivitiesTitleCSS)}>
        <Typography variant="body2Medium" sx={{ color: colors.textSecondary }}>
          {t("Dialog##download activities")}
        </Typography>

        <Tooltip
          title={t(`Schedules##download activities##date info tooltip`)}
          size="medium"
          placement="top"
          hasArrow
        >
          <span>
            <InfoIcon
              data-testid="download-activites-info-icon"
              height={14}
              width={14}
              css={css(infoIconCSS)}
            />
          </span>
        </Tooltip>
      </div>

      <DayRangePicker
        maxDate={moment()}
        externalValue={rangeValue}
        onChange={handleActivitiesRangeChange}
        customStyle={{
          paddingBottom: "16px"
        }}
        disableSameDay
      />
    </>
  );
};

export default DownloadActivitesRange;
